import React from "react";
import { Icon } from "@/elements-react/fix-icon";
import { FixButton } from "@/elements-react/fix-button";

const iconMap = {
    prev: "chevron-left",
    next: "chevron-right",
} as const;

export interface FixPagerArrowProps {
    type: "prev" | "next";
    disabled?: boolean;
    onClick?: () => void;
    className?: string;
    page?: number;
    currentUrl?: string;
}

export const FixPagerArrow = ({ type, disabled, onClick, className, page, currentUrl }: FixPagerArrowProps) => {
    const href = (() => {
        const [pathname = "", rawSearch = ""] = (currentUrl ?? "").split("?");
        const params = new URLSearchParams(rawSearch);

        if (!page || page <= 1) {
            params.delete("page");
        } else {
            params.set("page", String(page));
        }

        const q = params.toString();
        return q ? `${pathname}?${q}` : pathname;
    })();

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (disabled) return;
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

        e.preventDefault();
        e.stopPropagation();
        onClick?.();
    };

    return (
        <FixButton
            href={href}
            className={className}
            disabled={disabled}
            onClick={(e) => handleClick(e as any)}
            variant="text"
            aria-label={type}
        >
            {!iconMap[type] && <span>{type}</span>}
            <Icon name={iconMap[type]} />
        </FixButton>
    );
};